import React, { useState, useRef, useEffect } from 'react';
import { PlusCircle, User, LogOut, LogIn, ChevronDown } from 'lucide-react';
import './Header.css';

const Header = ({ onLogoClick, user, isSignedUp, onLogout, onNavigate, onPostStory }) => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleMenuClick = (action) => {
        setIsDropdownOpen(false);
        if (action === 'profile') {
            onNavigate('Me');
        } else if (action === 'logout') {
            onLogout();
        } else if (action === 'login') {
            onNavigate('Me');
        }
    };

    return (
        <header className="header">
            <div className="header-top">
                <h1 className="logo" onClick={onLogoClick}>Yatsite</h1>

                <div className="profile-section" ref={dropdownRef}>
                    <div
                        className="profile-icon-container"
                        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                    >
                        {isSignedUp && user?.images?.[0] ? (
                            <img
                                src={user.images[0]}
                                alt="Profile"
                                className="header-profile-img"
                            />
                        ) : (
                            <div className="header-profile-placeholder">
                                <User size={20} color="#6b7280" />
                            </div>
                        )}
                    </div>

                    {isDropdownOpen && (
                        <div className="profile-dropdown">
                            {isSignedUp ? (
                                <>
                                    <div className="dropdown-item" onClick={() => handleMenuClick('profile')}>
                                        <User size={16} />
                                        <span>My Profile</span>
                                    </div>
                                    <div className="dropdown-item" onClick={() => handleMenuClick('logout')}>
                                        <LogOut size={16} />
                                        <span>Sign Out</span>
                                    </div>
                                </>
                            ) : (
                                <div className="dropdown-item" onClick={() => handleMenuClick('login')}>
                                    <LogIn size={16} />
                                    <span>Sign In / Sign Up</span>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>

            <div className="header-story-bar" onClick={onPostStory}>
                <div className="story-input-mock">
                    <PlusCircle size={20} color="var(--primary)" />
                    <span>Post a new story...</span>
                </div>
            </div>
        </header>
    );
};

export default Header;
